import React from "react";
import { Popup, PopupHeading, PopupActions, PopupContent, PopupButton, } from "./Popup";
const MessageDialog = (props) => {
    return (React.createElement(Popup, { onBackdropPress: props.onBackdropPress },
        props.heading && React.createElement(PopupHeading, null, props.heading),
        React.createElement(PopupContent, null, props.content),
        React.createElement(PopupActions, null,
            React.createElement(PopupButton, { onClick: props.onOk, style: { minWidth: "100px" } }, "OK"))));
};
export default MessageDialog;
